import { useState, useEffect } from "react";

import Grid from "@mui/material/Grid";
import Divider from "@mui/material/Divider";

// Material Dashboard 2 React components
import MDBox from "../../components/MDBox";

// Material Dashboard 2 React example components
import DashboardLayout from "../../shared/LayoutContainers/DashboardLayout";
import DashboardNavbar from "../../shared/Navbars/DashboardNavbar";
import Footer from "../../shared/Footer";
import ProfileInfoCard from "../../shared/Cards/InfoCards/ProfileInfoCard";

// Overview page components
import Header from "./components/Header";
import BasicInfo from "./components/BasicInfo";

import ChangePassword from "./components/ChangePassword";
import authorService from "../../services/authorService";

function Overview() {
  const user = JSON.parse(localStorage.getItem("user"));
  const [setting, setSetting] = useState(false);
  const [userData, setUserData] = useState({
    _id: user.id,
    username: user.username,
    role: user.role,
    name: "",
    last_name: "",
    email: "",
    bio: "",
    social_media: {
      website: "",
      twitter: "",
      facebook: "",
      instagram: "",
      linkedin: "",
    }
  });

  useEffect(() => {
    const fetchAuthor = async () => {
      try {
        const response = await authorService.getAll();
        const authors = response.data;
        const currentAuthor = authors.find((a) => a.user._id === user.id);
        if (currentAuthor) {
          setUserData((prev) => ({
            ...prev,
            ...currentAuthor,
            _id: currentAuthor._id,
            name: currentAuthor.name,
            last_name: currentAuthor.last_name,
            email: currentAuthor.email || "",
            bio: currentAuthor.bio || "",
            social_media: currentAuthor.social_media || prev.social_media,
          }));
        }
      } catch (error) {
        console.error("Error fetching author:", error);
      }
    };
    fetchAuthor();
  }, [user.id]);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox mb={2} />
      <Header user={user} setSetting={setSetting}>
        {!setting ? (
          <MDBox mt={3} mb={3}>
            <Grid spacing={1} container>
              <Grid item xs={12} md={6} xl={6} sx={{ display: "flex" }}>
                <Divider orientation="vertical" sx={{ ml: -2, mr: 1 }} />
                <ProfileInfoCard
                  title="información del usuario"
                  info={{
                    Usuario: user.username,
                    Role: user.role,
                    Nombre: userData.name || "N/A",
                    Email: userData.email || "N/A",
                  }}
                  social={[]}
                  action={{ route: "", tooltip: "Editar Perfil", onClick: () => setSetting(true) }}
                  shadow={false}
                  description={userData.bio || "No hay biografía disponible."}
                />
                <Divider orientation="vertical" sx={{ mx: 0 }} />
              </Grid>
            </Grid>
          </MDBox>
        ) : (
          <MDBox mt={4}>
            <Grid container spacing={3}>
              <Grid item xs={12} lg={12}>
                <MDBox mb={3}>
                  <Grid container spacing={3}>
                    <Grid item xs={12}>
                      <BasicInfo userData={userData} setUserData={setUserData} />
                    </Grid>
                    <Grid item xs={12}>
                      <ChangePassword id={user.id} />
                    </Grid>
                  </Grid>
                </MDBox>
              </Grid>
            </Grid>
          </MDBox>
        )}
      </Header>
      <Footer />
    </DashboardLayout>
  );
}

export default Overview;

